import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20manga%20illustration%20collage%20with%20dynamic%20comic%20panels%2C%20Japanese%20manga%20style%20art%20with%20warm%20lighting%2C%20energetic%20composition%20with%20action%20lines%2C%20motion%20effects%2C%20bright%20warm%20coral%20and%20amber%20accents%2C%20decorative%20manga%20background%20with%20speech%20bubbles%2C%20professional%20digital%20art%2C%20clean%20composition&width=1800&height=900&seq=hero-manga-bg&orientation=landscape)',
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          禁漫天 — 官方正版入口与使用指南
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          快速、安全访问禁漫天官方平台，畅享海量漫画资源。提供最新入口地址、注册登录教程、内容分类导览及常见问题解答。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <Link
            to="/article/1"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
            访问官方入口
          </Link>
          <Link
            to="/article/4"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm md:text-base font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-book-read-line text-sm"></i>
            </div>
            查看使用教程
          </Link>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-5 h-5 flex items-center justify-center text-white/60">
            <i className="ri-arrow-down-s-line text-xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}